import { render, staticRenderFns } from "./PointsPagoReport.vue?vue&type=template&id=75ca88aa"
import script from "./PointsPagoReport.vue?vue&type=script&lang=js"
export * from "./PointsPagoReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports